/**
 * Compatibility shim for legacy imports. PageSEO and visible patient content
 * own search information. Do not emit hidden AI-only claims or invented dates.
 */
export default function AISearchOptimizer() {
  return null;
}
